import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./routes.js";

// 安装路由
Vue.use(VueRouter);

// 解决vue报错vue-router.esm.js?8c4f:2007 Uncaught (in promise) NavigationDuplicated {_name: “NavigationDuplicated”, name: “NavigationDuplicated”}
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
    return routerPush.call(this, location).catch(error => error);
};

const routerOption = {
    mode: "history",
    routes
};

const router = new VueRouter(routerOption);

// 获取vue实例
router.beforeEach((to, from, next) => {
    Vue.prototype.$Loading.start();
    const { authtoken, systemTitle, appId, companyId } = router.app.$store.getters;
    window.document.title = `${to.meta.title || ""} - ${systemTitle}`;
    // 无需登录即可查看
    if (to.meta.norpermission) {
        next();
    }
    // 未登录状态
    else if (!authtoken) {
        to.params.appId && router.app.$store.commit("updateAppId", to.params.appId);
        Vue.prototype.$goSso();
    }
    else if (to.name === "home") {
        next({
            name: "app",
            params: { appId, companyId }
        });
    }
    else {
        next();
    }

});

router.afterEach((to) => {
    Vue.prototype.$Loading.finish();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js